/**
 * The internal dependencies.
 */
import IconHome from '../../assets/images/temp/ico-house.png';
import IconReload from '../../assets/images/temp/ico-reload.png';
import IconCart from '../../assets/images/temp/ico-cart.png';
import IconCartInactive from '../../assets/images/temp/ico-cart-inactive.png';
import IconBriefcase from '../../assets/images/temp/ico-briefcase.png';
import IconBriefcaseInactive from '../../assets/images/temp/ico-briefcase-inactive.png';
import IconDrill from '../../assets/images/temp/ico-drill.png';
import IconDrillInactive from '../../assets/images/temp/ico-drill-inactive.png';

export default {
    home: IconHome,
    reload: IconReload,
    shop: {active: IconCart, inactive: IconCartInactive},
    stock: {active: IconBriefcase, inactive: IconBriefcaseInactive},
    working: {active: IconDrill, inactive: IconDrillInactive},
    quality: {active: IconCart, inactive: IconCartInactive},
    disponent: {active: IconCart, inactive: IconCartInactive},
    done: {active: IconCart, inactive: IconCartInactive},
}



// WEBPACK FOOTER //
// ./src/assets/data/navigation-icons.js